module.exports = __webpack_public_path__ + "files/4df7d6dee6d5179919b493defa06415a.png";